// src/pages/OurProductPage.js
import React from 'react';
import './OurProductPage.css';
import chatbotImage from '../image/chatbot-interface.png';

const products = [
  {
    icon: "🎓",
    title: "Educational Institution Management System",
    description:
      "A complete platform to manage students, faculty, attendance, examinations, and administration efficiently.",
  },
  {
    icon: "🏋️",
    title: "GYM Management System",
    description:
      "Manage gym memberships, trainers, attendance, payments, and fitness tracking with ease.",
  },
  {
    icon: "🏥",
    title: "Hospital Management System",
    description:
      "Comprehensive solution to handle patient records, doctor appointments, billing, and hospital workflow.",
  },
  {
    icon: "💊",
    title: "Pharmacy Billing Management System",
    description:
      "Smart pharmacy billing and inventory management system with automated stock and sales tracking.",
  },
];

const OurProductPage = () => {
  return (
    <div className="product-wrapper">

      {/* PRODUCTS HEADER (LIKE SERVICES) */}
      <section className="services-header">
        <div className="header-icon">📦</div>

        <h2>
          Our <span>Products</span>
        </h2>

        <p>
          We design and develop powerful digital products that simplify business operations,
          improve efficiency, and deliver smart solutions for modern organizations.
        </p>

        <p>
          From educational platforms and healthcare systems to billing and management
          software, our products are built with advanced technologies to ensure
          reliability, scalability, and seamless user experience.
        </p>
      </section>

      {/* PRODUCTS LIST */}
      <section className="latest-services">
        <div className="services-grid">
          {products.map((product, index) => (
            <div key={index} className="service-box">

              <div className="icon-circle">
                {product.icon}
              </div>

              <div className="text-block">
                <h3>{product.title}</h3>
                <p>{product.description}</p>
              </div>

            </div>
          ))}
        </div>
      </section>

      {/* CHATBOT HEADER */}
      <section className="services-header">
        <div className="header-icon">🤖</div>

        <h2>
          Our <span>Chatbot Product</span>
        </h2>

        <p>
          Our chatbot is a smart digital assistant that delivers instant answers,
          seamless support, and engaging conversations tailored to your needs.
        </p>

        <p>
          Powered by advanced AI and natural language processing, it understands
          context, boosts productivity, and handles tasks efficiently.
        </p>
      </section>

      {/* CHATBOT SECTION */}
      <section className="about-section">
        <div className="about-text">

          <h3>AI Chat Bot</h3>

          <p>
            Our intelligent chatbot enhances user interaction with AI by providing
            instant responses and personalized support.
          </p>

          <p>
            Built with machine learning and NLP technologies, it improves
            productivity, reduces workload, and ensures smooth digital interactions.
          </p>

          <button className="about-button">Explore Features</button>

        </div>

        <div className="about-image">
          <img src={chatbotImage} alt="Chatbot UI" />
        </div>
      </section>

      {/* WHY CHATBOT */}
      <section className="latest-services">

        <h2>Why Use Chatbots?</h2>

        <div className="services-grid">

          <div className="service-box">
            <div className="icon-circle">⏱️</div>
            <div className="text-block">
              <h3>24/7 Availability</h3>
              <p>Chatbots provide round-the-clock support and instant responses.</p>
            </div>
          </div>

          <div className="service-box">
            <div className="icon-circle">⚡</div>
            <div className="text-block">
              <h3>Faster Resolutions</h3>
              <p>Automates repetitive queries so human agents focus on complex tasks.</p>
            </div>
          </div>

          <div className="service-box">
            <div className="icon-circle">📊</div>
            <div className="text-block">
              <h3>Real-Time Learning</h3>
              <p>AI improves continuously using NLP and machine learning.</p>
            </div>
          </div>

          <div className="service-box">
            <div className="icon-circle">💬</div>
            <div className="text-block">
              <h3>Engaging Conversations</h3>
              <p>Provides personalized and interactive user experiences.</p>
            </div>
          </div>

        </div>
      </section>

      {/* BENEFITS */}
      <section className="subscribe-section">

        <h2>Key Benefits of Our Chatbot</h2>

        <ul className="benefit-list">
          <li>✔️ 24/7 availability with accurate responses</li>
          <li>✔️ Reduces operational workload and cost</li>
          <li>✔️ Easy integration with web and mobile apps</li>
          <li>✔️ Provides analytics for business insights</li>
          <li>✔️ Improves engagement and customer satisfaction</li>
        </ul>

      </section>

    </div>
  );
};

export default OurProductPage;